import { useEffect } from 'react';

const DEFAULT_SITE = '瓜哥吃瓜';

export function useDocumentMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title;

    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let element = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, key);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    return () => {
      document.title = `${DEFAULT_SITE} - 今日份新鲜事｜新瓜速递 最新更新快讯`;
    };
  }, [title, description]);
}